<template>
  <div class="not-found">
    <div class="not-found__content">
      <h1 class="not-found__code">404</h1>
      <p class="not-found__message">La page que vous recherchez n'existe pas.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

